import { render, staticRenderFns } from "./appointmentservicereport.vue?vue&type=template&id=8655e850&scoped=true&"
import script from "./appointmentservicereport.vue?vue&type=script&lang=js&"
export * from "./appointmentservicereport.vue?vue&type=script&lang=js&"
import style0 from "./appointmentservicereport.vue?vue&type=style&index=0&id=8655e850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655e850",
  null
  
)

export default component.exports